type GetFlagKeys =
  | `mfashown${string}`
  | 'askAiCoachMarkShown'
  | 'rudderAiIntroNudgeShown'
  | 'rudderAiPanelDismissed'
  | 'hasAcknowledgedGovernSection'
  | 'showEditorProfilesPopup'
  | `trialWelcomeShown:${string}`;

type GetKeys =
  | GetFlagKeys
  | 'visitedSources'
  | 'authError'
  | 'userStore'
  | 'lastVisitedWorkspace'
  | 'requestedWorkspace'
  | 'transformationEditor'
  | 'trackingPlanMigration'
  | 'lastVisitedOrgToWorkspaceMap'
  | 'profilesProjectsInfo'
  | 'lockDiffMode'
  | 'postLoginParams'
  | `getStartedCompleted:${string}`
  | `getStartedFirstEventFinished:${string}`
  | `getStartedEventReceivedBeforePick:${string}`
  | `getStartedSource:${string}`
  | `getStartedAgentSteps:${string}`
  | `getStartedAgentTab:${string}`;

type SetFlagKeys =
  | 'mfashown'
  | 'askAiCoachMarkShown'
  | 'rudderAiIntroNudgeShown'
  | 'rudderAiPanelDismissed'
  | 'showEditorProfilesPopup'
  | 'hasAcknowledgedGovernSection'
  | `trialWelcomeShown:${string}`;

type SetKeys =
  | SetFlagKeys
  | 'visitedSources'
  | 'userStore'
  | 'authError'
  | 'lastVisitedWorkspace'
  | 'transformationEditor'
  | 'trackingPlanMigration'
  | 'profilesProjectsInfo'
  | 'lastVisitedOrgToWorkspaceMap'
  | 'lockDiffMode'
  | 'postLoginParams'
  | `getStartedCompleted:${string}`
  | `getStartedFirstEventFinished:${string}`
  | `getStartedEventReceivedBeforePick:${string}`
  | `getStartedSource:${string}`
  | `getStartedAgentSteps:${string}`
  | `getStartedAgentTab:${string}`;

const LocalStorage = {
  setFlag(key: SetFlagKeys) {
    this.set(key, 'true');
  },

  isFlagSet(key: GetFlagKeys) {
    return this.get(key) === 'true';
  },

  get(key: GetKeys) {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      return null;
    }
  },

  set(key: SetKeys, value: string) {
    try {
      localStorage.setItem(key, value);
    } catch (err) {}
  },

  remove(key: GetKeys | SetKeys) {
    try {
      localStorage.removeItem(key);
    } catch (err) {}
  },
};

/* eslint-disable import/no-default-export */
export default LocalStorage;
